<div class="modal-container">
  <button
    id="modalDatosObservatorio"
    #modalDatosObservatorio
    data-bs-toggle="modal"
    data-bs-target="#modalAlerta2"
    hidden="hidden"
    hidden
  aria-hidden="true"
  tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalAlerta2"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content modal-content-govco">
        <div class="modal-header modal-header-govco">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="p-2 pt-4"></div>
        <div class="modal-body modal-body-govco">
          <div class="p-2">
          <app-form
            [title]="modalText['titulo_datos_observatorio']"
            [sumbitButtonText]="modalText['boton']"
            [fields]="allFields"
            (submitAction)="onSubmit($event)">
          </app-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
